import { defineStore } from 'pinia'

export const useMenuStore = defineStore('menu', {
  state: () => ({
    opened: {},
  }),

  actions: {
    open() {
      this.opened = true;
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.opened = false;
      document.body.style.overflow = 'auto';
    },
  }
});